import { UnidadeModel } from './unidade.model';
import { TipoComponenteModel } from './tipocomponente.mode';
import { TipoCaixaModel } from './../caixa/tipocaixa.model';
import { ModuloModel } from './modulo.model';
export class ComponenteModel {
    id: number;
    nome: String;
    ativo: Boolean;
    isAlocacaoRecipiente: Boolean;
    paridade: Number;
    isPai: Boolean;
    componentesFilhos: Array<ComponenteModel>;
    cor: String;
    altura: Number;
    largura: Number;
    profundidade: Number;
    posicaoHorizontal: Number;
    posicaoVertical: Number;
    componentePai: ComponenteModel;
    modulo: ModuloModel;
    ordenacao: String;
    tipoCaixa: TipoCaixaModel;
    tipoComponente: TipoComponenteModel;
    unidade: UnidadeModel;
}



// WEBPACK FOOTER //
// /app/src/app/model/endereco/componente.model.ts